/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Altersteilzeit1Inputs */



/**

* @param {_Class_Altersteilzeit1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_altersteilzeit1 = /** @type {((inputs?: _Class_Altersteilzeit1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Altersteilzeit1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Altersteilzeit")
});
export { _class_altersteilzeit1 as "_class_Altersteilzeit" }